<template>
    <div class="border rounded-md overflow-hidden cursor-pointer bg-white p-1 shadow-campaign" @click="clickCampaign(campaign)">
        <div class="campaign-image rounded-md" :style="{'background-image': `url('${campaign.fullImageUrl}')`}"></div>
        <div class="py-1">
            <div class="campaign-name text-22 text-blue-1">{{campaign.name}}</div>
            <div class="mt-2 px-4">
                <div v-if="campaign.type == campaignType.News || campaign.type == campaignType.Event"></div>
                <div v-else-if="campaign.type == campaignType.Privilege2" class="text-20 w-full bg-green-1 text-white rounded-full text-center py-2">{{ lbl.campaign.detail }}</div>
                <div v-else class="text-20 w-full bg-green-1 text-white rounded-full text-center py-2">{{getPointMessage()}}</div>
            </div>

        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import { CampaignType } from "@/helper/StaticValue.js";

export default {
    name: "CampaignItem",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    data: function() {
        return {
            campaignType: CampaignType
        }
    },
    methods: {
        getPointMessage: function () {
            let pointType = this.campaign.pointType == 'get' ? this.lbl.campaign.get_point : this.lbl.campaign.use_point;
            let pointUnit = this.lbl.campaign.point + (this.campaign.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + this.FilterNumberFormat(this.campaign.pointPerUnit) + " " + pointUnit;
        },

        clickCampaign: function(campaign) {
            this.tracking.event('home_campaign', 'click_campaign', campaign.id + '|' + campaign.name);
            if (!this.isCampaignTypeSurvey()) {
                this.$router.push('/campaign/' + this.campaign.id);
            } else {
                this.$router.push('/campaignSurvey/' + this.campaign.id);
            }
        },
        isCampaignTypeSurvey: function() {
            if (this.campaign.website == null) return false;
            return (this.campaign.type == CampaignType.Interface)
                && (this.campaign.website.indexOf('survey') >= 0);
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/text.scss";
    @import "@/style/base/image.scss";
    .campaign-name {
        height: 52px;
        @extend %ellipsis-2;
    }
    .campaign-image {
        @include boxRatio($ratio: 66.66%);
    }
</style>
